<div class="wrapper">
    <div class="top-ribbon"></div>
<div class="layout">
    <div class="error-screen">
        <p *ngIf="!isAcura"class="error-text">Activate your remote services trial <br> with HondaLink today. <br> Download app and get Started.</p>
        <p *ngIf="isAcura" class="error-text">Activate your remote services trial <br> with AcuraLink today. <br> Download app and get Started.</p>
        <p class="error-text2">When you put the car in drive, <br> this screen will switch to the normal mode</p>
    </div>
</div>
</div>